// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__nb5q5","signatureButtonsRight":"ModalSign_signatureButtonsRight__2O39f"};